import { useState } from "react"
import { ClipboardDocumentIcon, CheckIcon } from "@heroicons/react/16/solid"

export const CopyableId = ({ value, length = 10 }: { value: string; length?: number }) => {
  const [copied, setCopied] = useState(false)

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(value)
      setCopied(true)
      setTimeout(() => setCopied(false), 1500)
    } catch {
      // clipboard unavailable — ignore
    }
  }

  return (
    <button
      type="button"
      onClick={copy}
      title="Скопировать"
      className="inline-flex items-center gap-1 font-mono text-xs text-gray-500 hover:text-gray-800 transition-colors group/copy"
    >
      {value.slice(0, length)}…
      {copied
        ? <CheckIcon className="w-3 h-3 text-emerald-500 flex-shrink-0" />
        : <ClipboardDocumentIcon className="w-3 h-3 text-gray-300 group-hover/copy:text-gray-500 flex-shrink-0" />
      }
    </button>
  )
}